<template>
  <legal-page :content="content" />
</template>

<script>
import LegalPage from '../LegalPage.vue';
import rawMd from './cookie.md';

export default {
  name: 'CookiePage',
  components: { LegalPage },
  data() {
    return { content: rawMd };
  }
};
</script>
